module.exports = __webpack_public_path__ + "img/TLM.c6159aa2.svg";